export default __webpack_public_path__ + "static/media/RhymesBedtime_06.8548862c.png";